import { apiPost } from '../../api'

export const enroll_recruitee = data => {
  return apiPost({
    endpoint: `recruitment/enroll_recruitee`,
    data: data
  })
}
